attachEvent('.payment-method__open-modal', 'click', (ev) => {
  const parentElem = ev.target.closest('.payment-method');
  const paymentModal = parentElem.querySelector('.payment-modal');
  paymentModal.classList.add('is-open-modal');
  ev.preventDefault();
});

attachEvent('.payment-modal__close, .payment-modal__overlay, .payment-modal__content-main-toggle', 'click', (ev) => {
  const parentElem = ev.target.closest('.payment-modal');
  parentElem.classList.remove('is-open-modal');
  ev.preventDefault();
});

attachEvent('.payment-modal__content-main-slider', 'input', (ev) => {
  ev.preventDefault();
  const variants = document.querySelectorAll('.variants');
  const indexOfVariant = ev.target.value-1;
  if (variants[indexOfVariant]) {
    document.querySelector('.payment-modal__content-main-item-right strong').innerHTML = `${variants[indexOfVariant].dataset.month} x ${variants[indexOfVariant].value} €`;
  }
});
